import Icon from '../components/Icon.vue'

Icon.register({
  'fist-raised': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M256 160h-48c-5.6 0-11 1.2-16 2.9v-146.9c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v144zM384 256l0 88.2v0c0 22-12.6 52.4-28.1 67.9l-35.9 35.9v64h-256v-64l-26.5-26.5c-24-24-37.5-56.6-37.5-90.5v-77.9c5 1.8 10.4 3 16 3h32c12.3 0 23.5-4.8 32-12.5 8.5 7.7 19.7 12.5 32 12.5h32c7.9 0 15.3-2.1 21.9-5.5 7.5 16.3 21.6 28.9 38.9 34.5-17.1 14.8-31.6 34.5-47.3 58.1l-6.3 9.5c-0.7 1.1-1.3 3.1-1.3 4.4 0 2.4 1.6 5.3 3.6 6.7l13.3 8.9c1.1 0.7 3.1 1.3 4.4 1.3 2.4 0 5.3-1.6 6.7-3.6l6.3-9.5c31.9-47.8 51.5-70.3 96-72.5 4.3-0.2 7.9-3.7 7.9-8v-16.2c0-4.4-3.5-8-13.2-8h-35.3c-26.3 0-47.6-21.3-47.6-47.6v-0.6c0-8.8 7.1-15.8 15.9-15.8h112.1c35.3 0 64 28.7 64 64zM352 165.9c-10.1-3.6-20.7-5.9-32-5.9h-32v-112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v117.9zM16 224c-8.8 0-16-7.2-16-16v-128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-32zM112 224c-8.8 0-16-7.2-16-16v-160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16h-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fist-raised.js
// module id = 1357
// module chunks = 0